app.service('authorView', function(pageConfig, articleAdvice, lazyLoad, broker){
	let $self, $allArticlesList, $pagingSeparators, $pagination, $paginationProgress;
	let topArticlesCount, allArticlesCount, totalArticlesCount, articlesPaginationCount;
	let currentDisplayCount = 0;

	function showMoreArticles(){
		if(currentDisplayCount <= allArticlesCount){ 
			currentDisplayCount +=articlesPaginationCount;
		}
		displayActiveArticles();
	}
	function displayActiveArticles(){
		$allArticlesList.slice(0, currentDisplayCount).addClass('shown');
		lazyLoad.update();
		updatePaging();
	}
	function updatePaging(){
		if($pagingSeparators.length != 0){
			let pagingSeparatorNumber = Math.floor(currentDisplayCount/articlesPaginationCount);
			if (pagingSeparatorNumber > 1) {
				$pagingSeparators.slice(0, pagingSeparatorNumber-1).addClass('active');
				$pagingSeparators.slice(0, pagingSeparatorNumber-2).find('.paging-arrow.next').addClass('active');
			}
		}
		if(allArticlesCount <= currentDisplayCount){
			$pagination.addClass('hide');
			return;
		}
		if (currentDisplayCount > 0){
			$('.articles-visible-count', $pagination).text(topArticlesCount + currentDisplayCount);
			$paginationProgress.width(Math.ceil(currentDisplayCount/allArticlesCount*100)+'%');
		}
	}

	function setElements(){
		$self = $('#author-page');
		$pagingSeparators = $self.find('.all-articles-list .paging-separator');
		$pagination = $self.find('#author-articles-pagination');
		$paginationProgress = $self.find('.pagination-progress');
		topArticlesCount = $self.find('.top-articles-list .top-articles-item').length || 0;
		$allArticlesList = $self.find('.all-articles-list .all-articles-item');
		allArticlesCount = $allArticlesList.length || 0;
		totalArticlesCount = topArticlesCount + allArticlesCount;
		articlesPaginationCount = pageConfig.getData('author').articlesPaginationCount;
		currentDisplayCount = articlesPaginationCount;
	}
	function setEvents(){
		displayActiveArticles();
		$self.on('click','.js-more-author-description',function(){
			$(this).parent().toggleClass('show-long-description');
		}).on('click','.js-show-more-articles', function(){
			showMoreArticles();
		}).on('click', '.paging-separator a[href*="#"]',function(e){
			e.preventDefault();
			var elementOffset = $(this.hash).offset();
			if(elementOffset){
				$.scrollTo(elementOffset.top, 500);
			}
		});
	}
	function init(){
		setElements();
		setEvents();
		articleAdvice.init();
	}
	return{
		init: init
	};
});
